import TeamService from 'src/modules/team/teamService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'TEAM_FORM';

const teamFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: teamFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TeamService.find(id);
      }

      dispatch({
        type: teamFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: teamFormActions.INIT_ERROR,
      });

      getHistory().push('/team');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: teamFormActions.CREATE_STARTED,
      });

      await TeamService.create(values);

      dispatch({
        type: teamFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.team.create.success'),
      );

      getHistory().push('/team');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: teamFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: teamFormActions.UPDATE_STARTED,
      });

      await TeamService.update(id, values);

      dispatch({
        type: teamFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.team.update.success'),
      );

      getHistory().push('/team');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: teamFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default teamFormActions;
